import { AppleQualityTvExpVariants } from '.';
import { AppleQualityTvInteractions, ExperimentParams } from './types';

export const appleQualityTvParams: Record<AppleQualityTvExpVariants, AppleQualityTvInteractions<ExperimentParams>> = {
	control: {
		offers: {
			ct: 'exp-3-control-reg',
			itsct: 'justwatch_tv',
		},
		freeTrial: {
			ct: 'exp-3-control-natds',
			itsct: 'justwatch_tv_6',
		},
	},
	variant_1: {
		offers: {
			ct: 'exp-3-v1-reg',
			itsct: 'justwatch_tv',
		},
		freeTrial: {
			ct: 'exp-3-v1-natds-cta',
			itsct: 'justwatch_tv_11',
		},
		posters: {
			ct: 'exp-3-v1-natds-title',
			itsct: 'justwatch_tv_11',
		},
	},
};
